<template>
  <div data-qe-id="terms-modal">
    <modal-title>{{ $t('terms.main.title') }}</modal-title>
    <modal-content>
      <t-text class="terms-text" v-html="termsText"></t-text>
    </modal-content>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { marked } from 'marked'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const termsText = computed(() => {
  return marked(t('terms.main.terms'))
})
</script>

<style lang="less" scoped></style>
